import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { ConfigurationService } from '@app/configuration/configuration.service';
import { SimulationDao } from '@app/dao/simulation/simulation.dao';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

import { SubscriptionFacadeService } from '../../../services/subscription-facade.service';
import {
  forgetUnavailablePackChoice,
  pledgeHasScpiPacks,
  pledgeParameters,
} from '../../pledge-pack-choice';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@UntilDestroy()
@Component({
    selector: 'select-scpi',
    templateUrl: './select-scpi.component.html',
    styleUrls: ['./select-scpi.component.scss'],
    standalone: false
})
export class SelectSCPIComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  options = [];

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    private configurationService: ConfigurationService,
    private simulationDao: SimulationDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.subscriptionFacade.initForm(this);

    const pledge = this.subscriptionFacade.getPledge();

    this.options.push({
      label: 'Sélection Manuelle ',
      value: 'FREE',
      suffix: 'A',
      svg: 'manually-choose.svg',
    });
    let scpiOwnershipType = pledge?.parameters.scpiOwnershipType;
    if (scpiOwnershipType != 'USUFRUIT' && scpiOwnershipType != 'NU_PROPRIO') {
      pledgeHasScpiPacks(this.simulationDao, pledge)
        .pipe(untilDestroyed(this))
        .subscribe(hasPacks => {
          if (hasPacks) {
            this.options = [
              ...this.options,
              {
                label: `Choisir un Pack ${this.configurationService.getOrganizationName()}`,
                value: 'PACK',
                suffix: 'B',
                svg: 'package-choose.svg',
              },
            ];
          } else if (hasPacks === false) {
            forgetUnavailablePackChoice(
              this.form,
              'scpiSelectionType',
              this.subscriptionFacade,
              pledgeParameters,
            );
          }
        });
    }
  }

  onSubmit() {
    this.form.markAsDirty();
    const scpiPackId = this.subscriptionFacade.getPledge()?.parameters
      ?.scpiPackId as any;

    if (this.form.value.scpiSelectionType == 'PACK' || scpiPackId) {
      this.subscriptionFacade.submitPledge(this, 'pledgeAndResetProduct');
    } else {
      this.subscriptionFacade.submitPledge(this);
    }
  }
  extract() {
    return {
      ...this.form.value,
      scpiPackId:
        this.form.value.scpiSelectionType == 'PACK'
          ? this.subscriptionFacade.getPledge()?.parameters?.scpiPackId
          : null,
    };
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
